export default "__VITE_ASSET__BUntuBnX__"